<p-table styleClass="p-datatable-gridlines p-datatable-sm" [columns]="columnsTable" [value]="dataTable" dataKey="id"
   [tableStyle]="{ 'min-width': '50rem' }" [(selection)]="selectionItem" [expandedRowKeys]="expandedRows"
   [defaultSortOrder]="sortOrder" #dt>
   <ng-template pTemplate="caption" *ngIf="showCaption">
      <section class="w-full flex align-items-center justify-content-end gap-2">
         <p-button styleClass="hidden md:flex" *ngIf="configButtonToCheck && selectionItem.length > 0"
            [label]="configButtonToCheck.title" [icon]="configButtonToCheck.icon" severity="info"
            (click)="onClickButtonToCheck.emit()" />
         <p-button styleClass="hidden md:flex" *ngIf="configButtonToForm" [label]="configButtonToForm.title"
            [icon]="configButtonToForm.icon" severity="info" (click)="onClickButtonMassiveForm.emit(dataTable)" />
         <p-button styleClass="flex md:hidden" *ngIf="configButtonToCheck && selectionItem.length > 0"
            [icon]="configButtonToCheck.icon" severity="info" (click)="onClickButtonToCheck.emit()" size="small" />
         <p-button styleClass="flex md:hidden" *ngIf="configButtonToForm" [icon]="configButtonToForm.icon"
            severity="info" (click)="onClickButtonMassiveForm.emit(dataTable)" size="small" />
      </section>
   </ng-template>
   <ng-template pTemplate="header" let-columns>
      <tr>
         <th pSortableColumn="{{ col.field !== 'actions' ? col.field : '' }}" (click)="setInitialSort(dt ,col.field)"
            *ngFor="let col of columnsTable" class="text-center" [style.width]="col.type === 'expanded' ? '3rem' : ''">
            <ng-container *ngIf="col.type === 'check'; else defaultColumn">
               <p-tableHeaderCheckbox (click)="onChangeCheckbox.emit(selectionItem)" />
            </ng-container>
            <ng-template #defaultColumn>
               {{ col.header }}
               <p-sortIcon *ngIf="col.field !== 'actions'" field="{{ col.field }}"></p-sortIcon>
            </ng-template>
         </th>
      </tr>
   </ng-template>
   <ng-template pTemplate="body" let-rowData let-columns="columns" let-expanded="expanded">
      <tr>
         <td *ngFor="let col of columns;" [ngClass]="{
               'text-center': !col.type || col.type !== 'text_long', 
               'text-justify': col.type === 'text_long',
               'text-right': col.type === 'money' || columnasNumericas.includes(col.header),
               'text-left': columnasTexto.includes(col.header)
            }" [style.width]="col.header === 'Acciones' ? 36 * actionsTable.length +'px' : ''">
            <!-- [ngStyle]="getColumnStyle(col.header)" -->

            <ng-container *ngIf="col.field !== 'actions'; else actionsTemplate">

               <ng-container *ngIf="tablewithExpasionRow && col.type === 'expanded'">
                  <p-button type="button" [pRowToggler]="rowData" [text]="true" [rounded]="true" [plain]="true"
                     [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
                     [style]="{ 'outline': 'none', 'box-shadow': 'none' }" />
               </ng-container>

               <ng-container *ngIf="col.type === 'check'">
                  <p-tableCheckbox [value]="rowData" (click)="onChangeCheckbox.emit(selectionItem)"
                     [disabled]="rowData.isDisabled" />
               </ng-container>

               <ng-container *ngIf="col.type === 'radio'">
                  <p-tableRadioButton [value]="rowData" (click)="onChangeCheckbox.emit(selectionItem)"
                     [disabled]="rowData.isDisabled" />
               </ng-container>

               <ng-container *ngIf="col.type === 'select'">
                  <p-dropdown styleClass="w-full" [(ngModel)]="rowData[col.field]" [options]="col.options"
                     optionLabel="text" placeholder="Seleccione una opción" optionValue="value"
                     appendTo="body"></p-dropdown>
               </ng-container>

               <ng-container
                  *ngIf="(!col.type || col.type === 'text_long') && !columnasNumericas.includes(col.header) && col.header !== 'Avance %'">
                  <p style="margin-top: 8px; line-height: 1.05;">{{ rowData[col.field] }}</p>
               </ng-container>

               <ng-container *ngIf="col.type === 'date'">
                  {{ rowData[col.field] | date:'dd/MM/YYYY' }}
               </ng-container>

               <ng-container *ngIf="col.type === 'money' || columnasNumericas.includes(col.header)">
                  <span style="margin-right: 0.25rem;" class="">$</span>
                  <span>{{ rowData[col.field] | number:'1.2-2' }}</span>
               </ng-container>

               <ng-container *ngIf="col.header === 'Avance %'">
                  <p-progressBar [value]="rowData[col.field]"
                     [ngClass]="{'orientation-indicator': rowData[col.field] < 50}"></p-progressBar>
               </ng-container>

            </ng-container>
         </td>
         <ng-template #actionsTemplate>
            <td class="flex justify-content-center align-items-center gap-2 table-buttons-actions">
               <ng-container *ngFor="let button of actionsTable">
                  <ng-container *ngIf="!button.visible || (button.visible && button.visible(rowData))">
                     <app-boton-svg [nombre]="button.icon" [color]="button.typeButton" [size]="'28'"
                        [borderRadius]="'8'" (click)="onClickButtonTable.emit({ data: rowData, button: button })"
                        [pTooltip]="button.textAction" tooltipPosition="bottom" />
                  </ng-container>
               </ng-container>
            </td>
         </ng-template>
      </tr>
   </ng-template>
   <ng-template pTemplate="rowexpansion" let-rowData>
      <tr>
         <td [attr.colspan]="columnsTable.length">
            <div class="p-3">
               <p-table [value]="rowData[nameToPropertySublist]" dataKey="id" [columns]="columnsTableForExpasionRow">
                  <ng-template pTemplate="header" let-subColumns>
      <tr>
         <th *ngFor="let col of columnsTableForExpasionRow" class="text-center">
            {{ col.header }}
         </th>
      </tr>
   </ng-template>
   <ng-template pTemplate="body" let-rowData let-columns="columns">
      <tr>
         <td *ngFor="let col of columns;" class="text-center">
            <ng-container *ngIf="!col.type">
               {{ rowData[col.field] }}
            </ng-container>
            <ng-container *ngIf="col.type === 'date'">
               {{ rowData[col.field] | date:'dd/MM/YYYY' }}
            </ng-container>
            <ng-container *ngIf="col.type === 'money'">
               {{ rowData[col.field] | currency }}
            </ng-container>
         </td>
      </tr>
   </ng-template>
   <ng-template pTemplate="emptymessage">
      <tr>
         <td class="text-center font-semibold" [attr.colspan]="columnsTableForExpasionRow.length">No existe información
            disponible</td>
      </tr>
   </ng-template>
</p-table>
</div>
</td>
</tr>
</ng-template>
<ng-template pTemplate="emptymessage">
   <tr>
      <td class="text-center font-semibold" [attr.colspan]="columnsTable.length">No existe información disponible</td>
   </tr>
</ng-template>
</p-table>
<div *ngIf="configPaginator" class="flex sm:justify-content-end justify-content-center flex-wrap">
   <p-paginator [first]="configPaginator.first || 0" [rows]="configPaginator.rows || 0"
      [totalRecords]="configPaginator.total || 0" [showCurrentPageReport]="true" [showPageLinks]="false"
      [showJumpToPageDropdown]="false" currentPageReportTemplate="{first} - {last} Total: {totalRecords}"
      (onPageChange)="onChangePaginator.emit($event)" [rowsPerPageOptions]="[5, 10, 20, 30, 40, 50, 100, 200, 500, 1000]" />
</div>